import { Preset } from '@ekkogmbh/apisdk';
import CoordinateListItem from 'src/Common/Components/CoordinateListItem';
import PaginatedSelect from 'src/Common/Components/Forms/PaginatedSelect';

import useEkko from 'src/Common/Providers/EkkoProvider';
interface Props {
  optional?: boolean;
  onChange: (preset?: Preset) => void;
  value?: Preset;
  coordinate?: string;
}

export const PresetPicker = ({ coordinate, value, optional, onChange }: Props): React.JSX.Element => {
  const { api } = useEkko();

  return (
    <PaginatedSelect
      label={'Preset'}
      optional={optional}
      fetchPaginatedItems={(pagination) => api.getPresets(pagination, coordinate)}
      itemId={(item: Preset) => item.id.toString()}
      itemRender={(item: Preset) => <CoordinateListItem label={item.name} coordinate={item.coordinatePrefix} />}
      onChange={(item) => {
        onChange(item as Preset | undefined);
      }}
      value={value}
    />
  );
};
